import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import PropTypes from "prop-types";
import {
  Avatar,
  Box,
  Grid,
  Divider,
  Button,
  Popover,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TextField,
  TableSortLabel,
  InputAdornment,
  Paper,
  Pagination,
  PaginationItem,
  Select,
  MenuItem,
  Typography,
  usePagination,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import cssVariables from "../../theme/cssVariables";

import CustomPagination from "../../components/CustomPagination";

import planningImg from "../../assets/images/home/planning.svg";
import icon360 from "../../assets/icons/icon360V2.svg";
import MyGoalIcon from "../../assets/icons/goal.svg";
import CalibrationIcon from "../../assets/icons/calibration-inbox.svg";
import myFeedbackIcon from "../../assets/icons/myFeedback.svg";
import saveImg from "../../assets/images/home/save.svg";
import fileBrowser from "../../icons/file-browser.svg";
import Search from "@mui/icons-material/Search";
import { ReactComponent as FilterIcon } from "../../assets/icons/filter.svg";
import { ReactComponent as ChevronExpandDown } from "../../assets/icons/chevron-expand-down.svg";
import { ReactComponent as ChevronExpandUp } from "../../assets/icons/chevron-expand-up.svg";
import personImg from "../../assets/icons/person-fill.svg";
import indoxApi from "../../services/indox.service";

import ConfirmDialog from "../../components/inbox/ConfirmDialog";
import * as Util from "../../services/global.service";




// rest service
import { getInbox, patchReadInbox } from "../../actions/inbox";

function StylePaper(props) {
  return (
    <Paper sx={{ padding: "0.5rem 1.5rem", minHeight: "65vh" }}>
      {props.children}
    </Paper>
  );
}

function NoData() {
  const { t } = useTranslation();
  return (
    <TableRow>
      <TableCell colSpan={4} sx={{ borderBottom: "0!important" }}>
        <Box
          textAlign="center"
          sx={{ fontWeight: 300, flexFlow: "column", paddingTop: '18vh' }}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Box>
            <img src={fileBrowser} alt="browser" />
          </Box>
          <Box>
            <Typography color="#A0A0A0">{t("label.nodata")}</Typography>
          </Box>
        </Box>
      </TableCell>
    </TableRow>
  );
}

function formatData(data) {
  let result = {
    received: [],
    sent: []
  }
  const language = localStorage.getItem("lang");
  if (data.out ?? false) {
    for (const key of Object.keys(data.out)) {
      let tmpList = []
      tmpList = data.out[key].map((item, i) => {
        let rqt = ""
        if (item.type === "kpi") {
          if (item.sub_type === "evaluate") {
            rqt = language === "en-US" ? "Evaluation" : "การประเมิน"
            if (item.step_name) rqt += ': ' + item.step_name
          } else {
            rqt = language === "en-US" ? "Goal" : "เป้าหมาย"
          }
        } else if (item.type === "360") {
          rqt = language === "en-US" ? "360° Evaluation" : "360° Evaluation"
        } else if (item.type === "" || item.type === "probation" || item.type === "feedback") {
          if (item.sub_type === "feedback") {
            rqt = "Feedback"
          } else if (item.sub_type === "evaluate_feedback") {
            rqt = language === "en-US" ? "Evaluation Feedback" : "ความคิดเห็นการประเมินผล"
          } else {
            rqt = language === "en-US" ? "Evaluation" : "การประเมิน"
            if (item.step_name) rqt += ': ' + item.step_name
          }
        } else {
          rqt = item.rb_pa_step.name
        }
        let info = {
          serial: item?.message_id ?? "",
          name: language === "en-US" ? item?.requester?.fullname_en : item?.requester?.fullname_th,
          requestTitle: language === "en-US" ? item?.requester?.position_en : item?.requester?.position,
          profileImage: item?.requester?.photo ?? "",
          requestType: rqt,
          titleFeedback: Util.formatData(item?.options?.goal?.name, false) !== false ? item?.options?.goal?.name : Util.formatData(item?.options?.competency?.name, false) !== false ? item?.options?.competency?.name : Util.formatData(item?.options?.probation?.name, false) !== false ? item?.options?.probation?.name : item?.feedback_title,
          requestSubject: Util.formatData(item?.options?.goal?.name, false) !== false ? item?.options?.goal?.name : Util.formatData(item?.options?.competency?.name, false) !== false ? item?.options?.competency?.name : Util.formatData(item?.options?.probation?.name, false) !== false ? item?.options?.probation?.name : item.rb_pa ?? "",
          requestName: item?.name ?? "",
          createdDate: item?.created_at ?? "",
          type: item?.rb_pa_step?.step ?? "",
          status: item?.status ?? "",
          processStatus: key,
          isRead: item?.is_read,
          statusName: item?.status_name,
          workflowType: item?.type,
          feedback_member: item?.feedback_member,
          workflowSubType: item?.sub_type,
          evalType: item?.evaluate_type,
          formEvaluate: item?.form_evaluate,
          calibrationId: item?.calibration_id,
          calibrationName: Util.formatData(item?.options?.goal?.name, false) !== false ? item?.options?.goal?.name : Util.formatData(item?.options?.competency?.name, false) !== false ? item?.options?.competency?.name : Util.formatData(item?.options?.probation?.name, false) !== false ? item?.options?.probation?.name : Util.formatData(item?.options?.calibration?.name, false) !== false ? item?.options?.calibration?.name : item?.calibration_name,
          cycleStatus: item?.cycle_status,
          types: Util.formatData(item?.options, false) !== false ? Object.keys(item?.options) : "-"
        }

        if (item?.receiver?.code) {
          info.name = language === "en-US" ? item?.receiver?.fullname_en : item?.receiver?.fullname_th
          info.requestTitle = language === "en-US" ? item?.receiver?.position_en : item?.receiver?.position
          info.profileImage = item?.receiver?.photo ?? ""
        }
        //console.log('Out', item.statusName, item.name, item.cycleStatus)

        return info
      }).filter(item => item.statusName != "" && item.name && (item.cycleStatus != "inactive" && item.cycleStatus != "delete"))
      //console.log('Out List', data.out[key].length, tmpList)
      result.sent = [...result.sent, ...tmpList]
    }
  }

  if (data.in ?? false) {
    for (const key of Object.keys(data.in)) {
      let tmpList = []
      tmpList = data.in[key].map((item, i) => {
        let rqt = ""
        if (item.type === "kpi") {
          if (item.sub_type === "evaluate") {
            rqt = language === "en-US" ? "My Evaluation" : "การประเมินของฉัน"
            if (item.step_name) rqt += ': ' + item.step_name
          } else {
            rqt = language === "en-US" ? "My Goal" : "เป้าหมายของฉัน"
          }
        } else if (item.type === "360") {
          rqt = language === "en-US" ? "My 360° Evaluation" : "My 360° Evaluation"
        } else if (item.type === "" || item.type === "probation" || item.type === "feedback") {
          if (item.sub_type === "feedback") {
            rqt = "My Feedback"
          } else if (item.sub_type === "evaluate_feedback") {
            rqt = language === "en-US" ? "Evaluation Feedback" : "ความคิดเห็นการประเมินผล"
          } else {
            rqt = language === "en-US" ? "My Evaluation" : "การประเมินของฉัน"
            if (item.step_name) rqt += ': ' + item.step_name

          }
        } else {
          rqt = item.rb_pa_step.name
        }
        return {
          serial: item.message_id ?? "",
          name: language === "en-US" ? item?.requester?.fullname_en : item?.requester?.fullname_th,
          requestTitle: language === "en-US" ? item?.requester?.position_en : item?.requester?.position,
          requestType: rqt,
          titleFeedback: Util.formatData(item?.options?.goal?.name, false) !== false ? item?.options?.goal?.name : Util.formatData(item?.options?.competency?.name, false) !== false ? item?.options?.competency?.name : Util.formatData(item?.options?.probation?.name, false) !== false ? item?.options?.probation?.name : item?.feedback_title,
          requestSubject: Util.formatData(item?.options?.goal?.name, false) !== false ? item?.options?.goal?.name : Util.formatData(item?.options?.competency?.name, false) !== false ? item?.options?.competency?.name : Util.formatData(item?.options?.probation?.name, false) !== false ? item?.options?.probation?.name : item.rb_pa ?? "",
          requestName: item?.name ?? "",
          createdDate: item?.created_at ?? "",
          type: item?.rb_pa_step?.step ?? "",
          profileImage: item?.requester?.photo ?? "",
          status: item?.status ?? "",
          processStatus: key,
          isRead: item?.is_read,
          statusName: item?.status_name,
          workflowType: item?.type,
          feedback_member: item?.feedback_member,
          workflowSubType: item?.sub_type,
          evalType: item?.evaluate_type,
          formEvaluate: item?.form_evaluate,
          calibrationId: item?.calibration_id,
          calibrationName: Util.formatData(item?.options?.goal?.name, false) !== false ? item?.options?.goal?.name : Util.formatData(item?.options?.competency?.name, false) !== false ? item?.options?.competency?.name : Util.formatData(item?.options?.probation?.name, false) !== false ? item?.options?.probation?.name : Util.formatData(item?.options?.calibration?.name, false) !== false ? item?.options?.calibration?.name : item?.calibration_name,
          cycleStatus: item?.cycle_status,
          types: Util.formatData(item?.options, false) !== false ? Object.keys(item?.options) : "-"
        }
      }).filter(item => item.statusName != "" && (item.cycleStatus != "inactive" && item.cycleStatus != "delete"))
      result.received = [...result.received, ...tmpList]
    }
  }
  return result
}
const InboxLayout = (props) => {
  const _ = require("lodash");
  const [list, setList] = React.useState({ received: [], sent: [] });
  const [filteredList, setFilteredList] = React.useState([]);
  const [groupedReq, setGroupReq] = React.useState([]);
  const [perPage, setPerPage] = React.useState(10);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPage, setTotalPage] = React.useState(1);
  const dispatch = useDispatch();
  const inboxList = useSelector((state) => state.Inbox.inboxList)
  const navigate = useNavigate();
  const language = localStorage.getItem("lang");

  // first page load & set state
  useEffect(() => {
    dispatch(getInbox())
  }, [])
  useEffect(() => {
    let tmpState = { ...inboxList }
    setList(formatData(tmpState))
  }, [inboxList])
  useEffect(() => {
    const tmpState = { ...list }
    setFilteredList(tmpState[props.selectedInbox]?.sort((a, b) => {
      return String(b.createdDate).localeCompare(String(a.createdDate))
    }))


  }, [list])


  // go to detail page
  const handleGoToDetail = (serial, subType = null, evalType = null, feedback_member, messageId, type, row) => {
    dispatch(patchReadInbox(row.serial))
    const inboxType = props.selectedInbox;
    if (type === "360") {
      indoxApi.getRoute(serial).then((rs) => {
        if (rs?.data?.action === "manage") {
          navigate(`/kpi/360evaluation/manage/` + serial, { replace: false })
        } else if (rs?.data?.action === "evaluate") {
          navigate(`/kpi/360evaluation/${serial}/1`, { replace: false })
        } else if (rs?.data?.action === "result") {
          navigate(`/kpi/360evaluation/` + serial + "/result", { replace: false })
        }
      }).catch((err) => {

      })
    } else {
      if (subType === "evaluate") {
        if (evalType?.toLowerCase() !== "probation") {
          navigate(`/kpi/evaluation/` + serial, { replace: false })
        } else {
          navigate(`/kpi/probation-evaluation/` + serial, { replace: false })
        }
      } else if (subType === "calibration") {
        //navigate(`/kpi/inbox/calibration/${serial}/${messageId}`, { replace: false })
        navigate(`/kpi/calibration/${serial}`, { replace: false })
      } else if (subType === "feedback") {
        if (inboxType) {
          navigate(`/${props.path}/inbox/` + inboxType + "/" + feedback_member + "/feedback", { replace: false })
        }
      } else if (subType === "evaluate_feedback") {
        if (inboxType) {
          navigate(`/${props.path}/inbox/` + inboxType + "/" + feedback_member + "/feedback", { replace: false })
        }
      } else {
        if (inboxType) {
          navigate(`/${props.path}/inbox/` + inboxType + "/" + serial, { replace: false })
        }
      }
    }
  }

  const getInboxIcon = (item) => {
    if (item.workflowType === "kpi") {
      if (item.workflowSubType === "evaluate") {
        return planningImg
      } else {
        return MyGoalIcon
      }
    } else if (item.workflowType === "" || item.workflowType === "probation" || item.workflowType === "feedback") {
      if (item.workflowSubType === "calibration") {
        return CalibrationIcon
      } else if (item.workflowSubType === "feedback") {
        return myFeedbackIcon
      } else if (item.workflowSubType === "evaluate_feedback") {
        return myFeedbackIcon
      } else {
        return planningImg
      }
    } else if (item.workflowType === "360") {
      return icon360
    } else {
      if (item.type === 1) {
        return planningImg
      } else {
        return saveImg
      }
    }
  }

  const handlePerPageChange = (event) => {
    setPerPage(event.target.value);
  };
  const handleSetCurrentPage = (value) => {
    const getSelectedPage = value.filter(item => item.type === "page" && item.selected)
    setCurrentPage(getSelectedPage.length > 0 ? getSelectedPage[0].page : 1)
  };
  const handleTotalPage = () => {
    const List = filteredList.length > 0 ? filteredList.filter((item) => item.processStatus === tab) : []
    const totalPage =
      List.length > 0 ? Math.ceil(List.length / perPage) === 0
        ? 1
        : Math.ceil(List.length / perPage) : 1
    setTotalPage(totalPage);
  };

  const [tab, setTab] = React.useState("wait");
  const handleChange = (event, newValue) => {
    setCurrentPage(1);
    setTab(newValue);
  };

  useEffect(() => {
    handleTotalPage();
  }, [tab]);


  // handle search
  const [search, setSearchValue] = React.useState("");
  const handleSearch = (event) => {
    setSearchValue(event.target.value);
  };

  const [targetLabel, setTargetLabel] = React.useState('')

  // update listwhen inbox type changed
  useEffect(() => {
    if (props.selectedInbox === "received") {
      setTab("wait")
      setTargetLabel(t("inbox.label.requester"))
    } else if (props.selectedInbox === "sent") {
      setTab("inprogress")
      setTargetLabel(t("inbox.label.receiver"))
    }
    //console.log('props.selectedInbox', props.selectedInbox, list[props.selectedInbox])
    switch (props.selectedInbox) {
      case "received":
        setFilteredList(list.received);
        break;
      case "sent":
        setFilteredList(list.sent);
        break;
      default:
        break;
    }
  }, [props.selectedInbox]);
  // update qty for each status when list changed
  useEffect(() => {
    setGroupReq(_.groupBy(list[props.selectedInbox], (loRow) => loRow.processStatus))
  }, [filteredList]);
  // update list when search changed
  useEffect(() => {
    let result = [];
    if (search !== "") {
      result = list[props.selectedInbox].filter((item) => {
        return Object.keys(item).some((key) => {
          if (item[key]) {
            return item[key].toString().toLowerCase().indexOf(search) !== -1;
          }
          return item[key];
        });
      });
    } else {
      result = list[props.selectedInbox];
    }
    setFilteredList(result);
  }, [search])

  // data for show
  const currentTableData = useMemo(() => {
    handleTotalPage()
    const firstPageIndex = (currentPage - 1) * perPage;
    const lastPageIndex = firstPageIndex + perPage;
    return filteredList
      ?.filter((item) => item.processStatus === tab)
      .slice(firstPageIndex, lastPageIndex)
  }, [filteredList, currentPage, props.selectedInbox, tab, perPage]);

  // styles
  const useStyles = makeStyles({
    root: {
      fontSize: "16px",
      lineHeight: "24px",
      fontWeight: "400",
      // color: "#A0A0A0"
    },
    iconContainer: {
      width: 40,
      height: 40,
      borderRadius: 5,
      // marginTop: 3,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    profileContainer: {
      width: 40,
      height: 40,
      borderRadius: "50%",
      marginTop: 3,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    statusBadge: {
      width: "fit-content",
      minWidth: "120px",
      borderRadius: "5px",
      padding: "10px",
    },
    draftBg: {
      background: "#EFB76D26"
    },
    draftText: {
      color: "#EFB76D"
    },
    pendingBg: {
      background: "#F280261A"
    },
    pendingText: {
      color: "#F28026"
    },
    approveBg: {
      background: "#5DA19626"
    },
    approveText: {
      color: "#5DA196"
    },
    rejectedBg: {
      background: "#CC605826"
    },
    rejectedText: {
      color: "#CC6058"
    },
    cancelBg: {
      background: "#82828226",
    },
    cancelText: {
      color: "#828282",
    },
    cancelPendingBg: {
      background: "#82828226"
    },
    cancelPendingText: {
      color: "#828282",
    },
    completedBg: {
      background: "rgba(93, 161, 150, 0.15);",
    },
    completedText: {
      color: "#5DA196",
    },
    blueBg: {
      background: "#6694CC",
    },
    pinkBg: {
      background: "#E388B9",
    },
    purpleBg: {
      background: "#7580BD",
    },
    calibrationBg: {
      background: "#C36BA5",
    },
    feedbackBg: {
      background: "#AF7BC8",
    },
    btnContainer: {
      width: "100%",
      display: "flex",
      alignItems: "flex-start",
      flexGrow: 1,
    },
    btnActive: {
      background: cssVariables.color.primary,
      color: `${cssVariables.color.white}!important`,
      "&:hover": {
        backgroundColor: "#4f8a80",
      },
    },
    btnInactive: {
      "&:hover": {
        backgroundColor: "#5da19626",
      },
    },
    btn: {
      transition: "0.2s",
      cursor: "pointer",
      borderRadius: "5px",
      padding: "10px",
      color: cssVariables.color.black,
    },
    paginationRoot: {
      color: `${cssVariables.color.primary}`,
      backgroundColor: "white!important",
      minWidth: "30px!important",
      padding: "5px!important",
    },
    paginationSelected: {
      color: "white!important",
      border: "1px solid rgba(93, 161, 150, 0.5)!important",
      backgroundColor: `${cssVariables.color.primary}!important`,
      minWidth: "30px!important",
      padding: "5px!important",
    },
    tableHover: {
      transition: "0.5s",
      // "&:hover": {
      //   background: "#4043490f",
      //   cursor: "pointer",
      // },
      "&:hover": {
        // transform: "scale(1.01)",
        boxShadow: "3px 3px 5px rgba(0, 0, 0, 0.1)",
        cursor: "pointer",
        zIndex: 2
      },
    },
    unactiveSvg: {
      "& > path": {
        fill: "#6B6B6B"
      }
    },
    activeSvg: {
      "& > path": {
        fill: "#6B6B6B"
      }
    },
    searchSvg: {
      "& > path": {
        fill: "#C4C4C4",
      },
    },
  });

  const classes = useStyles();
  const { t } = useTranslation();

  const [order, setOrder] = React.useState('desc')
  const [orderBy, setOrderBy] = React.useState("createdDate")

  const handleRequestSort = (property, direction = "") => {
    if (direction === "") {
      const isAsc = orderBy === property && order === 'asc'
      setOrder(isAsc ? 'desc' : 'asc')
    } else {
      if (direction === "asc" || direction === "desc") {
        setOrder(direction)
      }
    }
    setOrderBy(property);
    // do sort
    let result = [...filteredList]
    result = result.sort((a, b) => {
      if (direction === "asc") {
        return String(a[property]).localeCompare(String(b[property]))
      } else {
        return String(b[property]).localeCompare(String(a[property]))
      }
    })
    setFilteredList(result)
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs>
        <Grid container>
          <Grid item xs="auto">
            <Tabs
              onChange={handleChange}
              value={tab}
              indicatorColor="primary"
              textColor="primary"
              aria-label="Tabs"
              TabIndicatorProps={{
                style: {
                  height: "8px",
                },
              }}
            >
              <Tab
                value="wait"
                label={
                  <span className={classes.root} style={{ textTransform: "none" }}>
                    {t("label.status.pending")} (
                    {groupedReq?.wait?.length ?? 0})
                  </span>
                }
                sx={{
                  display: props.selectedInbox === "received" ? "block" : "none",
                  color: tab === "wait" ? "#5DA196" : "#A0A0A0"
                }}
              />
              <Tab
                value="inprogress"
                label={
                  <span className={classes.root} style={{ textTransform: "none" }}>
                    {t("label.status.processing")} (
                    {groupedReq?.inprogress?.length ?? 0})
                  </span>
                }
                sx={{
                  color: tab === "inprogress" ? "#5DA196" : "#A0A0A0"
                }}
              />
              <Tab
                value="done"
                label={
                  <span className={classes.root} style={{ textTransform: "none" }}>
                    {t("label.status.completed")} (
                    {groupedReq?.done?.length ?? 0})
                  </span>
                }
                sx={{
                  color: tab === "done" ? "#5DA196" : "#A0A0A0"
                }}
              />
            </Tabs>
          </Grid>
          {/* <Grid item xs display="flex" flexDirection="row-reverse">
            <Box ml={1}>
              <Button
                variant="outlined"
                color="black"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={handleOpenFilterPopover}
              >
                <Box
                  mr={1}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <FilterIcon />
                </Box>
                <Box display="flex" alignItems="center" justifyContent="center">
                  {t("delete")}
                  ตัวกรอง
                </Box>
              </Button>
            </Box>
          </Grid> */}
          <Grid item sm={12} xs={12} md={4} ml="auto">
            <TextField
              id="input-with-icon-textfield"
              fullWidth
              placeholder={t("label.search")}
              size="small"
              sx={{ background: "#fff", borderColor: "#E5E5E5" }}
              className="searchTextField-h48"
              value={search}
              onChange={handleSearch}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search className={classes.searchSvg} />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
        <Grid container mt={2}>
          <Grid item xs sm md lg>
            <TableContainer component={StylePaper}>
              <Table sx={{ width: "100%" }} aria-label="simple table">
                <TableHead sx={{ borderBottom: "1px solid #e0e0e0" }}>
                  <TableRow>
                    <TableCell align="left" sortDirection="asc" display="flex" >
                      <Typography
                        fontWeight={500}
                        fontSize={16}
                        lineHeight="24px"
                        sx={{ color: "#A0A0A0", display: "flex" }}
                        component="span"
                      >
                        {t("inbox.label.requestName")}
                        {/* <TableSortLabel
                          active={orderBy === "requestName"}
                          direction={orderBy === "requestName" ? order : 'asc'}
                        /> */}
                        <Box sx={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                          <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => handleRequestSort("createdDate", "asc")} className={orderBy === "createdDate" && order === "asc" ? classes.activeSvg : classes.unactiveSvg} />
                          <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => handleRequestSort("createdDate", "desc")} className={orderBy === "createdDate" && order === "desc" ? classes.activeSvg : classes.unactiveSvg} />
                        </Box>
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography
                        fontWeight={500}
                        fontSize={16}
                        lineHeight="24px"
                        sx={{ color: "#A0A0A0", display: "flex" }}
                        component="span"
                      >
                        {t("inbox.label.list")}
                        {/* <TableSortLabel
                          active={orderBy === "requestSubject"}
                          direction={orderBy === "requestSubject" ? order : 'asc'}
                        /> */}
                        <Box sx={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                          <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => handleRequestSort("requestSubject", "asc")} className={orderBy === "requestSubject" && order === "asc" ? classes.activeSvg : classes.unactiveSvg} />
                          <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => handleRequestSort("requestSubject", "desc")} className={orderBy === "requestSubject" && order === "desc" ? classes.activeSvg : classes.unactiveSvg} />
                        </Box>
                      </Typography>

                    </TableCell>
                    <TableCell align="left">
                      <Typography
                        fontWeight={500}
                        fontSize={16}
                        lineHeight="24px"
                        sx={{ color: "#A0A0A0" }}
                      >
                        {targetLabel}
                      </Typography>
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{ width: "20%", maxWidth: "150px", display: 'none' }}
                      className="clickable"
                    >
                      <Typography
                        fontWeight={500}
                        fontSize={16}
                        lineHeight="24px"
                        sx={{ color: "#A0A0A0", display: "flex" }}
                        component="span"
                      >
                        {t("label.request.status")}
                        {/* <TableSortLabel
                          active={orderBy === "statusName"}
                          direction={orderBy === "statusName" ? order : 'asc'}
                        /> */}
                        <Box sx={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                          <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => handleRequestSort("statusName", "asc")} className={orderBy === "statusName" && order === "asc" ? classes.activeSvg : classes.unactiveSvg} />
                          <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => handleRequestSort("statusName", "desc")} className={orderBy === "statusName" && order === "desc" ? classes.activeSvg : classes.unactiveSvg} />
                        </Box>
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentTableData.length > 0 ? (
                    currentTableData.map((row) => {
                      ///console.log(row.processStatus, tab)

                      return (row.processStatus !== tab) ? (
                        <></>
                      ) : (
                        <TableRow
                          key={row.id}
                          sx={{
                            // "&:last-child td, &:last-child th": { border: 0 },
                            background: row.isRead ? "#FAFAFA" : "#fff",
                            position: "relative"
                          }}
                          classes={{ root: classes.tableHover }}
                          onClick={() => handleGoToDetail(row?.workflowSubType === "evaluate" ? row.formEvaluate : row?.workflowSubType === "calibration" ? row.calibrationId : row.serial, row.workflowSubType, row?.evalType, row?.feedback_member, row.serial, row?.workflowType, row)}
                        >
                          <TableCell align="left" sx={{ width: "250px" }}>
                            <Box
                              display="flex"
                              sx={{
                                flexFlow: "column",
                                textAlign: "left",
                                marginLeft: 2,
                                position: "relative",
                              }}
                            >
                              {!row.isRead ? (
                                <div
                                  style={{
                                    position: "absolute",
                                    marginLeft: "-20px",
                                    marginTop: "10px",
                                    width: "10px",
                                    height: "10px",
                                    background: "#CC6058",
                                    borderRadius: "50%",
                                  }}
                                ></div>
                              ) : (
                                <></>
                              )}
                              <Typography
                                variant="h4"
                                fontWeight={500}
                                fontSize={18}
                                color="#404349"
                              >
                                {language === "en-US" ?
                                  row.requestName === "คำขออนุมัติ" ? "Request for Approval" :
                                    row.requestName === "คำขอยกเลิกอนุมัติ" ? "Request for Cancel Approval" :
                                      row.requestName === "คำขอประเมินผล" ? "Request for Evaluation" :
                                        row.requestName === "คำขอลงนาม" ? "Request for Sign Off" :
                                          row.requestName === "คำขอเลือกผู้ประเมิน" ? "Request for Assign"
                                            : row.requestName : row.requestName
                                }
                              </Typography>
                              <Typography variant="sub_label" lineHeight="27px" fontSize={14} fontWeight={400} sx={{ color: "#939393" }}>
                                {Util.dateDayTimeFormat(row.createdDate)}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell align="left">
                            <Box display="flex">
                              <div
                                className={`${classes.iconContainer} ${row.workflowType === "360" ?
                                  classes.pinkBg
                                  : row.workflowSubType === "calibration" ?
                                    classes.calibrationBg
                                    : row.workflowSubType === "feedback" || row.workflowSubType === "evaluate_feedback" ?
                                      classes.feedbackBg
                                      : row.type == 1
                                        ? classes.blueBg
                                        : classes.purpleBg
                                  }`}
                              >
                                <img
                                  src={getInboxIcon(row)}
                                  alt="bannerImage"
                                />
                              </div>
                              <Box
                                display="flex"
                                sx={{ flexFlow: "column", width: "calc(100% - 40px)", paddingLeft: "20px" }}
                              >
                                <Typography
                                  variant="h4"
                                  fontWeight={500}
                                  fontSize={18}
                                  color="#404349"
                                  sx={{ textTransform: "capitalize!important" }}
                                >
                                  {row?.workflowSubType !== "calibration" ? row.requestType : row.workflowSubType}
                                </Typography>
                                <Typography
                                  variant="h6"
                                  fontSize={14}
                                  className="fw-400"
                                  sx={{
                                    color: "#939393", fontWeight: "400!important",
                                    display: "-webkit-box",
                                    "-webkit-line-clamp": "1",
                                    "-webkit-box-orient": "vertical",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {row?.workflowSubType === "feedback" || row?.workflowSubType === "evaluate_feedback" ? row?.titleFeedback : row?.workflowSubType !== "calibration" ? row.requestSubject : row.calibrationName} {row?.workflowSubType === "evaluate_feedback" ? "(" + row?.types + ")" : ""}
                                </Typography>
                              </Box>
                            </Box>
                          </TableCell>
                          <TableCell align="left">
                            <Box display="flex">
                              {
                                row.profileImage ?
                                  <img
                                    className={`${classes.profileContainer}`}
                                    src={row.profileImage}
                                    alt="profile"
                                    onError={({ currentTarget }) => {
                                      currentTarget.onerror = null;
                                      currentTarget.src = personImg;
                                    }}
                                  /> : <Avatar className={`${classes.profileContainer}`} />
                              }
                              <Box
                                display="flex"
                                alignItems="flex-start"
                                ml={2}
                                sx={{ flexFlow: "column" }}
                              >
                                <Typography
                                  variant="h4"
                                  fontWeight={500}
                                  fontSize={18}
                                  color="#404349"
                                >
                                  {row.name}
                                </Typography>
                                <Typography
                                  variant="h5"
                                  fontSize={14}
                                  sx={{ color: "#939393", fontWeight: "400!important" }}
                                >
                                  {row.requestTitle}
                                </Typography>
                              </Box>
                            </Box>
                          </TableCell>
                          <TableCell align="center" sx={{ display: 'none' }}>
                            <div
                              className={`${classes.statusBadge} ${row.statusName === "ระหว่างการแก้ไข" || row.statusName === "ระหว่างดำเนินการ" || row.status === "draft" || row.statusName === "In Progress"
                                ? classes.draftBg
                                : row.statusName === "ระหว่างการอนุมัติ" || row.status === "pending"
                                  ? classes.pendingBg
                                  : row.statusName === "อนุมัติเสร็จสิ้น" || row.status === "approve" || row.status === "approved" || row.status === "complete" || row.status === "completed"
                                    ? classes.approveBg
                                    : row.statusName === "ปฏิเสธ" || row.status === "reject" || row.status === "rejected"
                                      ? classes.rejectedBg
                                      : row.statusName === "ยกเลิกเสร็จสิ้น" || row.status === "cancel"
                                        ? classes.cancelBg
                                        : classes.cancelPendingBg
                                }`}
                            >
                              <Typography
                                className={
                                  row.statusName === "ระหว่างการแก้ไข" || row.statusName === "ระหว่างดำเนินการ" || row.status === "draft" || row.statusName === "In Progress"
                                    ? classes.draftText
                                    : row.statusName === "ระหว่างการอนุมัติ" || row.status === "pending"
                                      ? classes.pendingText
                                      : row.statusName === "อนุมัติเสร็จสิ้น" || row.status === "approve" || row.status === "approved" || row.status === "complete" || row.status === "completed"
                                        ? classes.approveText
                                        : row.statusName === "ปฏิเสธ" || row.status === "reject" || row.status === "rejected"
                                          ? classes.rejectedText
                                          : row.statusName === "ยกเลิกเสร็จสิ้น" || row.status === "cancel"
                                            ? classes.cancelText
                                            : classes.cancelPendingText
                                }
                                fontWeight={500}
                              >
                                {/* {t("label.status." + row.status)} */}
                                {Util.upperFirstWord(row.statusName)}
                              </Typography>
                            </div>
                          </TableCell>
                        </TableRow>
                      )
                    }
                    )
                  ) : (
                    <NoData></NoData>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid container mt={1} spacing={2}>
            <Grid item xs sm md display="flex" alignItems="center">
              <Box mr={1}>
                <Typography variant="s14_fw400">{t("label.showMaxItems")}</Typography>
              </Box>
              <Select
                id="pagination"
                variant="outlined"
                defaultValue={5}
                value={perPage}
                onChange={handlePerPageChange}
                displayEmpty
                size="small"
                className="white-bg"
              >
                <MenuItem value={10}>
                  <Typography style={{ fontWeight: "300" }}>10</Typography>
                </MenuItem>
                <MenuItem value={50}>
                  <Typography style={{ fontWeight: "300" }}>50</Typography>
                </MenuItem>
                <MenuItem value={100}>
                  <Typography style={{ fontWeight: "300" }}>100</Typography>
                </MenuItem>
              </Select>
            </Grid>
            <Grid item display="flex" alignItems="center" ml="auto">
              <Typography variant="s14_fw400">
                {t("label.page")} {currentPage} {t("label.of")} {totalPage}
              </Typography>
            </Grid>
            <Grid item ml="auto" display="flex" alignItems="center">
              <CustomPagination
                setCurrentPage={handleSetCurrentPage}
                selected={currentPage}
                count={totalPage}
              ></CustomPagination>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default InboxLayout;
